import React from 'react';

import {
  CuiLink,
  CuiPage,
  CuiPageContent,
  CuiPageSubTitle,
  CuiPageTitle,
} from '../../components';

export const NotFoundPage = () => (
  <CuiPage isWide isCentered>
    <CuiPageContent>
      <CuiPageTitle>
        Zounds! It seems that this page doesn&rsquo;t exist.
      </CuiPageTitle>

      <CuiPageSubTitle>
        May we interest you in returning to{' '}
        <CuiLink to={{ type: 'HOME' }}>the home page?</CuiLink>
      </CuiPageSubTitle>
    </CuiPageContent>
  </CuiPage>
);



// WEBPACK FOOTER //
// ./ui/views/app/NotFoundPage.js